import { createContext } from "react";

export const HeaderContext = createContext({
  EasyWinPageUrl: "",
  ShouldEnableSpotTheBallTestOption: false,
  CheckoutURL: "",
  TierClass: "",
});
